import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LangContext';
import { localePath } from '@/lib/seo-data.mjs';

export function Footer() {
  const { copy, lang } = useLang();
  return (
    <footer>
      <div>
        <div className="brand">VIRTUS</div>
        <small style={{ display: 'block', marginTop: 8, opacity: 0.65 }}>
          {copy.footer.rights}
        </small>
      </div>
      <div className="footer-legal">
        <small>{copy.footer.company}</small>
        <Link className="footer-privacy" to={localePath('/privacy', lang)}>
          {copy.footer.privacy}
        </Link>
      </div>
    </footer>
  );
}
